// import React, { useEffect } from "react";
import { Button, Result } from "antd";
import { useLocation } from "react-router-dom";
import "./Success.css";

const Success = () => {
  const { state } = useLocation();
  const { message } = state || {};

  return (
    <div className="success-container">
      <Result
        className="fade-in"
        status="success"
        // title={message || "Submission Successful!"}
        subTitle="Thank you for your valuable feedback and choosing PSG Hospital. Wishing you good health."
        extra={[
          <Button
            key="home"
            type="primary"
            onClick={() => (window.location.href = "/feedback")}
            className="back-home-button"
          >
            {" "}
            Back To Home
          </Button>,
        ]}
      />
    </div>
  );
};

export default Success;
